import React from 'react'
import { useInsightsModal } from '../../hooks/hooks'
import SheetWrapper from '../containers/SheetWrapper';

const InsightsModal = ({ content }) => {

  const { id, isOpen, onClose } = useInsightsModal();

  // TODO: MIGHT REPLACE WITH REACT-SHEET-WRAPPER

  const onChange = (open) => {
    if (!open) {
      onClose();
    }
  }

  switch (id) {
    case "empreinte":
      content =
      {
        title: "L'empreinte globale",
        descr: "Insights on LAWWD's impact across the globe.",
        body: (
          <div>
            <h2>Hello</h2>
          </div>
        )
      }
        ;
      break;
    default:
      content = null /* (
        <div>
          <h2>Default Insights</h2>
        </div>
      ) */;
      break;
  }

  return (
    <SheetWrapper resp key={"Empreinte Insights"} showLogo isOpen={isOpen} setIsOpen={onChange} sheetDescr={content?.descr} hasCloseButton hasBackdrop hasHeader sheetTitle={content?.title ?? "Some insights"}>
      <div id="Sheet.Content" className='flexVfull py-20 items-start justify-center  text-white paddingX'>
        {content?.body}
      </div>
    </SheetWrapper>
  )
}

export default InsightsModal